import { CompanyType } from "@/Enums/CompanyType";

export enum EnvironmentVariable {
    BASE_URL = "EnvBaseUrl",
    COMPANY_TYPE = "EnvCompanyType",
}

const getEnvironmentVariable = (variable: EnvironmentVariable): string => {
    const metaElement: HTMLMetaElement | null = document.querySelector(`meta[name="${variable}"]`);
    return metaElement?.content || "";
}

export const baseURL = getEnvironmentVariable(EnvironmentVariable.BASE_URL);

const parseCompanyType = (companyType: string): CompanyType | null => {
    const parsedCompanyType = parseInt(companyType);
    if (isNaN(parsedCompanyType)) return null;
    switch (parsedCompanyType) {
        case CompanyType.KOOPERATIVA:
        case CompanyType.KOMUNALNA:
            return parsedCompanyType;
        default:
            return null;
    }
}

export const companyType = parseCompanyType(getEnvironmentVariable(EnvironmentVariable.COMPANY_TYPE));

export const getCompanyLogoUrl = () => {
    switch (companyType) {
        case CompanyType.KOOPERATIVA:
            return "https://static.koop.sk/pics/Kooperativa.svg";
        case CompanyType.KOMUNALNA:
            return "https://static.kpas.sk/pics/Kpas-logo.png";
        default:
            return "";
    }
}

export const getCompanyPortalName = (type: CompanyType) => {
    switch (type) {
        case CompanyType.KOMUNALNA:
            return "eKomfort";
        case CompanyType.KOOPERATIVA:
        default:
            return "eKooperativa";
    }
}

